import type { ReactNode } from 'react';
import { ToastProvider } from '@easymoving/ui';
import { AuthProvider } from './context/AuthContext';
import { WorkspaceProvider } from './context/WorkspaceContext';
import { BackendProvider } from './lib/backend/context';
import { MigrationGate } from './components/app/MigrationGate';

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <AuthProvider>
      <WorkspaceProvider>
        <BackendProvider>
          <ToastProvider>
            <MigrationGate>{children}</MigrationGate>
          </ToastProvider>
        </BackendProvider>
      </WorkspaceProvider>
    </AuthProvider>
  );
}
